import { WorkingCenterShippingServiceModelType } from '@teinor/erp/types/company/workingCenter/workingCenterShippingService'
import { VerticalSortItem } from '../../../../../../../../../../baseComponents/Sorts/VerticalSortList/types'

type ItemsSortWorkingCenterShippingService = VerticalSortItem & {
    WorkingCenterId: number
    ShippingServiceId: number
}
type WorkingCenterShippingServiceModelTypeExtended = WorkingCenterShippingServiceModelType & {
    'ShippingService.name': string
    'ShippingService.ShippingCompany.name': string
}

export const parseShippingServiceWorkingCenter = (arrShippingServiceWC: WorkingCenterShippingServiceModelTypeExtended[]) => {
    const myDataParsed: ItemsSortWorkingCenterShippingService[] = []
    for (const shippingService of arrShippingServiceWC) {
        myDataParsed.push({
            id: String(shippingService.ShippingServiceId), order: shippingService.order, name: shippingService['ShippingService.ShippingCompany.name'] + ' - ' + shippingService['ShippingService.name'], ShippingServiceId: shippingService.ShippingServiceId, WorkingCenterId: shippingService.WorkingCenterId
        })
    }
    return myDataParsed

}